import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { changeLanguageAction } from '../../reducers/data';
import navigationmenu from '../../data/navigation_bck.json';
import HeaderComponent from '../../helper/Navigationhelper';

import i18next, { t } from 'i18next';


class Header extends HeaderComponent {

    constructor(props) {
        super(props);
        this.changeSelectLanguage = this.changeSelectLanguage.bind(this);
    }


    changeSelectLanguage(language) {
        const { changeLanguageAction } = this.props

        i18next.changeLanguage(language);

        changeLanguageAction(language);
    }

    render() {
        // language, 
        const { blockSticky } = this.props;

        const stickyheader = (blockSticky || this.state.isTop) ? 'sticky' : '';



        return (
            <header className="header-style-1">
                {/* Start Topbar */}
                <div className="topbar-style-1">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-12 col-md-12 col-12">
                                <div className="left-side">
                                    <div className="language-box">
                                        <div className="language p-relative">
                                            <img style={{ width: "20px" }} src={process.env.PUBLIC_URL + `/assets/images/flag${i18next.language}.png`} alt="flag" />
                                            <select value={i18next.language} onChange={(e) => this.changeSelectLanguage(e.target.value)}>
                                                <option value='es' >{t("lang_es")}</option>
                                                <option value='en'>{t("lang_en")}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <p className="text-custom-white no-margin">
                                        {t("address_location")}
                                    </p>
                                </div>
                            </div>
                            {/* <div className="col-lg-6 col-md-6 col-12">
                                <div className="right-side">
                                     <ul className="custom">
                                        <li className="search">
                                            <Link to="#" className="text-custom-white fs-14" onClick={this.searchToggle}>
                                                <i className={classNames("fas fa-search", { "fa-times": this.state.searchmethod })} />
                                            </Link>
                                        </li>
                                        <li className={classNames("topbar-search", { "search-visible": this.state.searchmethod })}>
                                            <form method="get">
                                                <input type="search" className="form-control form-control-custom" name="search" placeholder={t("search_placeholder")} />
                                            </form>
                                        </li>
                                    </ul> 
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                {/* End Topbar */}
                {/* Start Navigation */}
                <div className={`main-navigation-style-1 ${stickyheader}`}>
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="navigation">
                                    <div className="logo">
                                        <Link to="/">
                                            <img src={process.env.PUBLIC_URL + "/assets/images/londonbank/logo/logo_white_london.png"} className="img-fluid image-fit-w" alt="logo" />
                                        </Link>
                                    </div>
                                    <div className={classNames("main-menu", { "active": this.state.navmethod })}>
                                        <div className="mobile-logo">
                                            <Link to="/">
                                                <img src={process.env.PUBLIC_URL + "assets/images/londonbank/logo/logo_black_london.png"} className="img-fluid image-fit-w" alt="logo" />
                                            </Link>
                                        </div>
                                        <nav>
                                            <ul className="custom">
                                                {navigationmenu.length > 0 ? navigationmenu.map((item, i) => (
                                                    <li key={i} className={`menu-item ${item.child ? 'menu-item-has-children' : ''} `} onClick={this.triggerChild}>
                                                        {item.child ? <Link className="text-custom-white" onClick={e => e.preventDefault()} to="/"> {t(item.linkText)} </Link> : <Link to={item.link} className="text-custom-white"> {t(item.linkText)} </Link>}
                                                        {item.child ?
                                                            <ul className="custom sub-menu" role="menu">
                                                                {item.submenu.map((sub_item, i) => (
                                                                    <li key={i} className={`menu-item ${sub_item.child ? 'menu-item-has-children' : ''} `}>
                                                                        {sub_item.child ? <Link className="text-light-grey" onClick={e => e.preventDefault()} to="/"> {t(sub_item.linkText)} </Link> : <Link className="text-light-grey" to={sub_item.link}> {t(sub_item.linkText)} </Link>}
                                                                        {sub_item.submenu ?
                                                                            <ul className="custom sub-menu">
                                                                                {sub_item.submenu.map((third_item, i) => (
                                                                                    <li className="menu-item" key={i}><Link className="text-light-grey"
                                                                                        to={third_item.link}>{t(third_item.linkText)}</Link>
                                                                                    </li>
                                                                                ))}
                                                                            </ul> : null}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                            : null
                                                        }
                                                    </li>
                                                )) : null}
                                            </ul>
                                        </nav>
                                        <div className="right-side">
                                            <div className="cta-btn">
                                                <Link to="/login" className="btn-first btn-submit">{t("virtual branch people")}</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="hamburger-menu">
                                        <div className={classNames("menu-btn", { "active": this.state.navmethod })} onClick={this.toggleNav}> <span />
                                            <span />
                                            <span />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Navigation */}
            </header>
        );
    }
}


const mapStateToProps = state => {
    // console.log(state);
    return {
        language: state.data.language
    }
};
const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeLanguageAction
    }, dispatch)
);


export default connect(mapStateToProps, mapDispatchToProps)(Header);
